import React from 'react';
import { TextLink, Text } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { FootnoteReference } from '../../../../components';
import { DealerLabelContainer } from '../styles/CarinfoWrapper.styles';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '../../../utils';
import DealerChainPopover from './DealerChainPopover';
export const DealerInfoRethink = ({ vehicleBasic, isPLP }) => {
    var _a, _b, _c, _d, _e, _f;
    if (!((vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel) && ((_a = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel) === null || _a === void 0 ? void 0 : _a.code))) {
        return null;
    }
    const businessModelCode = vehicleBasic.businessModel.code;
    const stockType = vehicleBasic.type === 'U' ? 'uc' : 'nc';
    const isInvestorShared = ((_b = vehicleBasic.dealer.dealerContextLinkData) === null || _b === void 0 ? void 0 : _b.length) > 1;
    const groupName = ((_c = vehicleBasic.dealer.dealerContextLinkData.find((obj) => obj.originalGroupName)) === null || _c === void 0 ? void 0 : _c.originalGroupName) || null;
    const getHeadlineOrLabel = (isHeadline) => {
        if (isHeadline) {
            return useI18n({
                id: `stockcars.${stockType}.${businessModelCode}.dealer.headline`,
                defaultMessage: '',
            });
        }
        return useI18n({
            id: `stockcars.${stockType}.${businessModelCode}.dealer.label`,
            defaultMessage: '{{dealerName}}',
        });
    };
    const investorSharedLabel = useI18n({
        id: `stockcars.investor-shared-vehicle.label`,
        defaultMessage: '{{originalGroupName}}',
    });
    const headlineAria = useI18n({
        id: `stockcars.${stockType}.${businessModelCode}.dealer.headline.arialabel`,
        defaultMessage: '',
    });
    const labelAria = useI18n({
        id: `stockcars.${stockType}.${businessModelCode}.dealer.label.arialabel`,
        defaultMessage: '{{dealerName}}',
    });
    const headlineAriaToRender = headlineAria.replace('{{dealerName}}', ((_d = vehicleBasic.dealer) === null || _d === void 0 ? void 0 : _d.name) || '');
    const labelAriaToRender = labelAria
        .replace('{{dealerName}}', ((_e = vehicleBasic.dealer) === null || _e === void 0 ? void 0 : _e.name) || '')
        .replace('{{originalGroupName}}', groupName || '');
    const investorSharedLabelToRender = investorSharedLabel.replace('{{originalGroupName}}', groupName);
    const dealerHeadlineWithFootnote = renderTextWithFootnotesReferencesV2(getHeadlineOrLabel(true));
    const dealerLabelWithFootnote = renderTextWithFootnotesReferencesV2(getHeadlineOrLabel());
    const dealerHeadline = String(dealerHeadlineWithFootnote[0]).replace('{', '').trim();
    const dealerFootnoteRef = dealerHeadlineWithFootnote[1] && React.isValidElement(dealerHeadlineWithFootnote[1])
        ? dealerHeadlineWithFootnote[1].props.footnoteId
        : '';
    const labelFootnoteRef = dealerLabelWithFootnote[1] && React.isValidElement(dealerLabelWithFootnote[1])
        ? dealerLabelWithFootnote[1].props.footnoteId
        : '';
    const configuredDealerLabel = String(dealerLabelWithFootnote[0]);
    const dealerLabelToRender = configuredDealerLabel
        .replace('{{dealerName}}', (_f = vehicleBasic.dealer) === null || _f === void 0 ? void 0 : _f.name)
        .replace('{', '')
        .trim();
    const dealerOrInvestorsharedLabelToRender = isInvestorShared
        ? investorSharedLabelToRender
        : dealerLabelToRender;
    const scrollToDealerInfo = () => {
        const dealerInfoElement = document.getElementById('dealer-info');
        if (dealerInfoElement) {
            dealerInfoElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
            return true;
        }
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
        });
        return false;
    };
    return (React.createElement(DealerLabelContainer, { isPLP: isPLP, "data-testid": "dealerLabelWrapper" },
        React.createElement(Text, { "data-testid": "dealerHeadline", tag: "span", "aria-label": headlineAriaToRender, margin: [0, 0, dynamicStylingHelper(SYS_SPACE_FIXED_50, '0'), 0], variant: {
                order: dynamicStylingHelper('2', '3'),
                type: 'copy',
                style: 'normal',
            } },
            dealerHeadline,
            dealerFootnoteRef && (React.createElement(FootnoteReference, { refId: dealerFootnoteRef, "data-testid": "dealerFootnoteRef" }))),
        !isPLP ? (React.createElement(TextLink, { "data-testid": "dealerNameOrLabel", icon: "forward", iconPosition: "trailing", margin: [0, 0, 0, 0], onClick: scrollToDealerInfo, size: "sm", "aria-label": labelAriaToRender, variant: "standalone" }, dealerOrInvestorsharedLabelToRender)) : (React.createElement(React.Fragment, null, !isInvestorShared ? (React.createElement(Text, { "data-testid": "dealerNameOrLabelPlp", tag: "span", "aria-label": labelAriaToRender, margin: [0, 0, dynamicStylingHelper(SYS_SPACE_FIXED_50, '0'), 0], variant: {
                order: dynamicStylingHelper('2', '3'),
                type: 'copy',
                style: 'normal',
            } },
            dealerOrInvestorsharedLabelToRender,
            labelFootnoteRef && (React.createElement(FootnoteReference, { refId: labelFootnoteRef, "data-testid": "dealerFootnoteRef" })))) : (React.createElement(DealerChainPopover, { "data-testid": "dealerChain-link", ariaLabel: labelAriaToRender, label: investorSharedLabelToRender, vehicle: vehicleBasic }))))));
};
